@switch (true) {
  @case (credentialInfo().provider === "LEGIC_CONNECT" || credentialInfo().provider === "HID") {
    @if (redirectTo) {
      <app-redirect [message]="'credential.wallet_redirect' | translate"
                    [url]="redirectTo"></app-redirect>
    } @else {
      <a class="inline-block"
         (click)="onStartProvision()"
         id="googleButton">
        <img src="/assets/google_add_to_wallet.svg"
             [alt]="'platform.android.start' | translate"
             class="h-12 mx-auto"
        />
      </a>
    }
  }
  @case (credentialInfo().provider === "WAVELYNX") {
    @if (redirectTo) {
      <app-redirect [message]="'credential.provider_redirect' | translate"
                    [url]="redirectTo"></app-redirect>
    }
  }
  @default {
    <p class="text-gray-500 font-medium">
      {{ 'credential.provider_unsupported' | translate }}
    </p>
  }
}
